<script>
import LayoutMember from '@layout/Member'
import { messageWarning, messageSuccess } from '@utils/message'
// import { AREA_CODE } from '@src/config/location'
import { authComputed } from '@store/helpers'
import ValidDialog from '@components/Dialog/ValidDealer.vue'
// function telCodeOption() {
//   return AREA_CODE.map((item) => {
//     return {
//       text: item.code,
//       value: item.code,
//     }
//   })
// }
function formatDefaultValue(data) {
  const { backupEmail, email, name, mobilePhone, mobilePhoneCode, uuid, subscribeNewsletter, backupMobilePhone, group, company } = data
  // const newsletterAliasList = newsletterSubscriptions.map(({ alias }) => alias)
  // const companyObject = {
  //   name: '',
  //   email: '',
  //   vat: '',
  //   phone: '',
  //   extNumber: '',
  //   department: '',
  //   jobTitle: '',
  //   industry: '',
  //   scale: '',
  //   purchaseRole: '',
  //   interestedIssue: [],
  //   issueOther: '',
  // }
  const companyObject = {}
  if (company) {
    Object.keys(company).forEach((key) => {
      companyObject[`company${key}`] = company[key]
    })
  }
  return {
    backupEmail,
    email,
    name,
    mobilePhone,
    mobilePhoneCode,
    uuid,
    backupMobilePhone,
    subscribeNewsletter: !!subscribeNewsletter,
    group,
    ...companyObject,
  }
}

function formatStoreData(data) {
  const { backupEmail, email, name, mobilePhone, mobilePhoneCode, uuid, subscribeNewsletter, backupMobilePhone, group, ...company } = data
  const companyObject = {}
  Object.keys(company).forEach((key) => {
    companyObject[key.split('company')[1]] = company[key]
  })

  return {
    backupEmail,
    email,
    name,
    uuid,
    backupMobilePhone,
    subscribeNewsletter: subscribeNewsletter ? 1 : 0,
    group,
    company: companyObject,
  }
}

export default {
  page() {
    return {
      title: `會員設定`,
    }
  },
  components: {
    LayoutMember,
    ValidDialog,
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    buttonStyle: {
      type: String,
      default: 'isStylePrimary isSmall isRadius isOutline2',
    },
  },
  data() {
    return {
      submitData: {
        uuid: '',
        name: '',
        mobilePhone: '',
        mobilePhoneCode: '',
        backupMobilePhone: '',
        backupMobilePhoneCode: '',
        email: '',
        backupEmail: '',
        group: '',
        companyname: '',
        companyemail: '',
        companyvat: '',
        companyphone: '',
        companyphoneCode: '',
        companyextNumber: '',
        companyjobCategory: '',
        companyjobTitle: '',
        companydepartment: '',
        companyjobType: '',
        companyindustry: '',
        companyscale: '',
        companypurchaseRole: '',
        companyinterestedIssue: [],
        companyissueOther: '',
        companyphones: [],
        // newsletterSubscriptions: [],
        subscribeNewsletter: false,
        /* company: {
          name: "",
          email: "",
          vat: "",
          phone: "",
          extNumber: "",
          department: "",
          jobTitle: "",
          industry: "",
          scale: "",
          purchaseRole: "",
          interestedIssue: [],
          issueOther: '',
        }, */
        ...formatDefaultValue(this.defaultValue),
      },
      filedList: [
        {
          col: 12,
          type: 'text',
          label: '姓名',
          placeholder: '',
          name: 'name',
          rules: 'require',
          immediate: true,
        },
        {
          col: 12,
          type: 'mobilePhone',
          label: '手機(會員帳號)',
          placeholder: '',
          name: 'mobilePhone',
          rules: 'require',
          description: ``,
          immediate: true,
        },
        {
          col: 5,
          type: 'text',
          label: '公司統編',
          placeholder: '',
          name: 'companyvat',
          rules: this.isDealerCompany ? 'require|companyid|checkDealerVat' : 'companyid',
          immediate: true,
        },
        {
          col: 7,
          type: 'text',
          label: '公司名稱',
          placeholder: '',
          name: 'companyname',
          rules: 'require',
          immediate: true,
        },
        {
          col: 12,
          type: 'companyEmail',
          label: '公司信箱',
          placeholder: '',
          name: 'companyemail',
          rules: this.isDealerCompany ? 'require|email|companyemail' : 'require|email',
          // rules: `require|companyemail:${this.comapnyEmailDomain}`,
          description: `若註冊<span class="color-primary">經銷會員</span>，請必填公司全名、公司統編、公司電話和公司信箱！`,
          immediate: true,
        },
        {
          col: 12,
          type: 'personalEmail',
          label: '個人信箱',
          placeholder: '',
          name: 'email',
          rules: 'require|email',
          description: `個人信箱是作為若您公司信箱無法正常投遞時備用。`,
          immediate: true,
        },
        {
          col: 12,
          type: 'addPhone',
          label: '公司電話',
          placeholder: '請選擇區碼',
          name: 'companyphones',
          rules: 'require',
          phones: [
            {
              phoneCode: '',
              phone: '',
              ext: '',
            },
          ],
        },
        // {
        //   col: 3,
        //   type: 'select',
        //   label: '公司電話',
        //   placeholder: '區碼',
        //   name: 'companyphoneCode',
        //   rules: 'require',
        //   options: telCodeOption(),
        //   rulesName: '區碼',
        //   immediate: true,
        // },
        // {
        //   col: 6,
        //   type: 'text',
        //   label: '市內電話',
        //   placeholder: '市內電話',
        //   name: 'companyphone',
        //   rules: 'require|number',
        //   immediate: true,
        //   isTransparentLabel: true,
        // },
        // {
        //   col: 3,
        //   type: 'text',
        //   label: '分機',
        //   placeholder: '分機',
        //   name: 'companyextNumber',
        //   rules: '',
        //   isTransparentLabel: true,
        // },
        // {
        //   col: 12,
        //   type: 'backupMobilePhone',
        //   label: '備援手機',
        //   placeholder: '請輸入手機號碼',
        //   name: 'backupMobilePhone',
        //   rules: '',
        //   immediate: true,
        // },
        {
          col: 12,
          type: 'jobCategroy',
          label: '職務類別',
          placeholder: '請選擇',
          name: 'companyjobCategory',
          rules: 'require',
          immediate: true,
        },
        {
          col: 12,
          type: 'position',
          label: '職位別',
          placeholder: '請選擇',
          name: 'companyjobType',
          rules: 'require',
          immediate: true,
        },
        {
          col: 12,
          type: 'text',
          label: '部門',
          placeholder: '請輸入您所在的部門',
          name: 'companydepartment',
          rules: '',
          immediate: true,
        },
        {
          col: 12,
          type: 'text',
          label: '職稱',
          placeholder: '請輸入您的職稱',
          name: 'companyjobTitle',
          rules: '',
          immediate: true,
        },
        {
          col: 12,
          type: 'companyIndustry',
          label: '公司產業別',
          placeholder: '請選擇',
          name: 'companyindustry',
          rules: 'require',
          immediate: true,
        },
        // {
        //   col: 12,
        //   type: 'companySize',
        //   label: '公司規模',
        //   placeholder: '請選擇',
        //   name: 'companyscale',
        //   rules: 'require',
        //   immediate: true,
        // },
        {
          col: 12,
          type: 'role',
          label: '請問您在採購過程中所扮演的角色',
          placeholder: '請選擇',
          name: 'companypurchaseRole',
          rules: 'require',
          immediate: true,
        },
        {
          col: 12,
          type: 'companyinterestedIssue',
          label: '請問您對於下列哪些議題感興趣(複選)',
          placeholder: '請選擇',
          name: 'companyinterestedIssue',
          rules: 'require',
          immediate: true,
        },
        {
          col: 12,
          type: 'newsletter',
          label: '',
          description: '',
          name: 'filed13',
          rules: '',
        },
      ],
      loadingStoreMember: false,
      isDealerCompany: false,
      comapnyEmailDomain: '',
      noVat: 'none',
      memberSettingFixedBottom: true,
      step: 1,
      isDialogValidVisible: false,
      dialogData: {
        type: 3, // 1 補欄位 2 驗證資格 3 詢問驗證
        title: '是否升級成為經銷會員',
        text1: '您已具備經銷會員資格',
        text2: '是否現在升級？',
      },
    }
  },
  computed: {
    ...authComputed,
    dialogEmail: {
      get() {
        return this.submitData.companyemail
      },
    },
    // filedList() {
    //   return [
    //     {
    //       col: 12,
    //       type: 'text',
    //       label: '姓名',
    //       placeholder: '',
    //       name: 'name',
    //       rules: 'require',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'mobilePhone',
    //       label: '手機(會員帳號)',
    //       placeholder: '',
    //       name: 'mobilePhone',
    //       rules: 'require',
    //       description: ``,
    //       immediate: true,
    //     },
    //     {
    //       col: 5,
    //       type: 'text',
    //       label: '公司統編',
    //       placeholder: '',
    //       name: 'companyvat',
    //       rules: this.isDealerCompany ? 'require|companyid|checkDealerVat' : 'require|companyid',
    //       immediate: true,
    //     },
    //     {
    //       col: 7,
    //       type: 'text',
    //       label: '公司名稱',
    //       placeholder: '',
    //       name: 'companyname',
    //       rules: 'require',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'addPhone',
    //       label: '公司電話',
    //       placeholder: '請選擇區碼',
    //       name: 'phones',
    //       rules: 'require',
    //       innerOptions: [
    //         {
    //           phoneCode: '',
    //           phone: '',
    //           ext: '',
    //         },
    //       ],
    //     },
    //     // {
    //     //   col: 3,
    //     //   type: 'select',
    //     //   label: '公司電話',
    //     //   placeholder: '區碼',
    //     //   name: 'companyphoneCode',
    //     //   rules: 'require',
    //     //   options: telCodeOption(),
    //     //   rulesName: '區碼',
    //     //   immediate: true,
    //     // },
    //     // {
    //     //   col: 6,
    //     //   type: 'text',
    //     //   label: '市內電話',
    //     //   placeholder: '市內電話',
    //     //   name: 'companyphone',
    //     //   rules: 'require|number',
    //     //   immediate: true,
    //     //   isTransparentLabel: true,
    //     // },
    //     // {
    //     //   col: 3,
    //     //   type: 'text',
    //     //   label: '分機',
    //     //   placeholder: '分機',
    //     //   name: 'companyextNumber',
    //     //   rules: '',
    //     //   isTransparentLabel: true,
    //     // },
    //     {
    //       col: 12,
    //       type: 'email',
    //       label: '公司信箱',
    //       placeholder: '',
    //       name: 'companyemail',
    //       rules: this.isDealerCompany ? `require|companyemail:${this.comapnyEmailDomain}` : 'require|email',
    //       // rules: `require|companyemail:${this.comapnyEmailDomain}`,
    //       description: `若註冊<span class="color-primary">經銷會員</span>，請必填公司全名、公司統編、公司電話和公司信箱！`,
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'email',
    //       label: '個人信箱',
    //       placeholder: '',
    //       name: 'email',
    //       rules: 'require|email',
    //       description: `備用私人E-mail, 訊息不漏接`,
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'backPhone',
    //       label: '備援手機',
    //       placeholder: '請輸入手機號碼',
    //       name: 'backPhone',
    //       rules: '',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'jobCategroy',
    //       label: '職務類別',
    //       placeholder: '請選擇',
    //       name: 'companyjobCategory',
    //       rules: 'require',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'position',
    //       label: '職位別',
    //       placeholder: '請選擇',
    //       name: 'companyjobType',
    //       rules: 'require',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'companyIndustry',
    //       label: '公司產業別',
    //       placeholder: '請選擇',
    //       name: 'companyindustry',
    //       rules: 'require',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'companySize',
    //       label: '公司規模',
    //       placeholder: '請選擇',
    //       name: 'companyscale',
    //       rules: 'require',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'role',
    //       label: '請問您在採購過程中所扮演的角色',
    //       placeholder: '請選擇',
    //       name: 'companypurchaseRole',
    //       rules: 'require',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'companyinterestedIssue',
    //       label: '請問您對於下列哪些議題感興趣(複選)',
    //       placeholder: '請選擇',
    //       name: 'companyinterestedIssue',
    //       rules: 'require',
    //       immediate: true,
    //     },
    //     {
    //       col: 12,
    //       type: 'newsletter',
    //       label: '',
    //       description: '',
    //       name: 'filed13',
    //       rules: '',
    //     },
    //   ]
    // },
  },
  watch: {
    isDealerCompany: function (newValue) {
      // if (this.currentMember.group === '一般會員') return
      if (newValue) {
        this.filedList.forEach((item, index) => {
          if (item.name === 'companyemail') {
            this.filedList[index].rules = 'require|email|companyemail'
          }
        })
      } else {
        this.filedList.forEach((item, index) => {
          if (item.name === 'companyemail') {
            this.filedList[index].rules = 'require|email'
          }
        })
      }
    },
  },
  async created() {
    await this.checkVat()
  },
  destroyed() {
    this.step = 1
  },
  methods: {
    onSubmit() {
      this.tryToStoreMember()
    },
    async sendDealerVaildEmail() {
      await this.$store.dispatch('auth/sendDealerVaildEmail')
    },
    levelUp() {
      this.tryToStoreMember().then(() => {
        this.sendDealerVaildEmail()
        this.dialogData = {
          type: 2, // 1 補欄位 2 驗證資格 3 詢問驗證
          title: '收取驗證連結',
          text1: `已發送驗證連結至您的電子郵件${this.submitData.companyemail}`,
          text2: '請點選信件內的連結以驗證成為經銷會員',
        }
        this.isDialogValidVisible = true
      })
    },
    notNow() {
      this.step = 2
      this.tryToStoreMember()
    },
    onMobileSubmit() {
      this.tryToStoreMember().then(() => {
        this.$router.push({
          name: 'member-info',
        })
      })
    },
    // isDealer() {
    //   return this.defaultValue?.groupId === 6
    // },
    async tryToStoreMember() {
      this.loadingStoreMember = true
      const formattedSubmitData = formatStoreData(this.submitData)
      await this.$store
        .dispatch('auth/storeUser', formattedSubmitData)
        .then(() => {
          messageSuccess('修改成功')
          this.$store.dispatch('auth/fetchUser')
          this.$store.dispatch('auth/setLock', true)
        })
        .catch((e) => {
          messageWarning(e.message)
        })
        .finally(() => {
          this.loadingStoreMember = false
        })
      // setTimeout(() => {
      //   this.loadingStoreMember = false;
      //   messageSuccess('修改成功')
      // }, 1000)
    },
    async tryToCheckVat() {
      await this.$store
        .dispatch('global/checkVat', this.submitData?.companyvat)
        .then(({ items }) => {
          this.$store.dispatch('auth/setCompanyLevel', items.category_name)
          this.comapnyEmailDomain = items.mailDomains.domain ?? ''
          this.submitData.companyname = items.name
          this.noVat = 'success'
          // this.submitData.companyphone = items.phone;
          if (items['category_name'] === '經銷會員' || items['category_name'] === '零壹員工') {
            this.isDealerCompany = true
            // if(this.submitData.companyemail && this.comapnyEmailDomain !== this.submitData.companyemail.split('@')[1]) {
            //   // console.log(this.$refs.form.$refs.companyemail[0].$el)
            //   // this.$refs.form.$refs.companyemail[0].$el.focus()
            //   console.log('test')
            //   this.$alert('此為經銷公司，請確認信箱跟公司是否匹配', {
            //     customClass: 'isStyleBase',
            //     title: '信箱確認',
            //     confirmButtonText: '確定',
            //     showClose: false
            //   })
            // }
          } else {
            this.isDealerCompany = false
          }
        })
        .catch((e) => {
          if (e.code === 404) {
            this.noVat = 'none'
            this.comapnyEmailDomain = ''
            this.isDealerCompany = false
          }
        })
    },
    checkVat(vat) {
      const companyidRegExp = new RegExp(/^[0-9]{8}$/)
      if (companyidRegExp.test(this.submitData?.companyvat)) {
        this.tryToCheckVat(vat)
      } else {
        this.isDealerCompany = false
        this.noVat = 'none'
      }
    },
    addPhone() {
      this.filedList.forEach((item, index) => {
        if (item.type === 'addPhone') {
          this.filedList[index].phones.push({
            phoneCode: '',
            phone: '',
            ext: '',
          })
        }
      })
    },
  },
}
</script>
<template>
  <LayoutMember :class="$style.layoutMember">
    <template v-slot:banner>
      <BaseBanner title="會員設定" :image="require('@assets/images/member/banner.png')" custom-class="isStyleWhite" class="d-md-block d-none" />
    </template>
    <div class="d-md-block d-none">
      <template v-if="step === 1">
        <template v-if="currentMember.group === '經銷會員' && currentMember.dealerValidate === false">
          <div class="member-state">
            <div class="member-state-ineer"> 您已具備經銷會員資格，請填寫並確認欄位資訊，即可驗證成為經銷會員 </div>
          </div>
        </template>
        <BaseForm
          ref="form"
          v-model="submitData"
          :list="filedList"
          :dialog-data="dialogData"
          :loading="loadingStoreMember"
          :fixed-bottom="memberSettingFixedBottom"
          :no-vat="noVat"
          cancel-text=""
          confirm-text="儲存修改"
          button-style="isStylePrimary isRadius"
          @phone="addPhone"
          @vat="checkVat"
          @notNow="notNow"
          @levelUp="levelUp"
          @submit="onSubmit"
        />
      </template>
      <template v-if="step === 2">
        <div class="saveSuccess">
          <p class="title">儲存成功!</p>
          <p class="text">已儲存您編輯的資料</p>
        </div>
      </template>
    </div>
    <div class="d-md-none">
      <template v-if="step === 1">
        <BaseForm
          ref="form"
          v-model="submitData"
          :list="filedList"
          :dialog-data="dialogData"
          :loading="loadingStoreMember"
          :fixed-bottom="memberSettingFixedBottom"
          :no-vat="noVat"
          cancel-text=""
          confirm-text="儲存修改"
          button-style="isStylePrimary isRadius"
          @phone="addPhone"
          @vat="checkVat"
          @submit="onMobileSubmit"
        />
      </template>
      <template v-if="step === 2">
        <div class="saveSuccess">
          <p class="title">儲存成功!</p>
          <p class="text">已儲存您編輯的資料</p>
        </div>
      </template>
    </div>
    <ValidDialog :visible.sync="isDialogValidVisible" :dialog-data="dialogData" @confirm="isDialogValidVisible = false" />
  </LayoutMember>
</template>
<style lang="scss" module>
.layoutMember {
  :global {
    .member-state {
      width: 70%;
      display: flex;
      justify-content: center;
      background-color: $color-gray-1;
      color: $color-primary;
      padding: 10px 15px;
      font-size: 16px;
      margin: 0 auto 60px;
      .member-state-ineer {
        display: flex;
        justify-content: center;
      }
    }
    .saveSuccess {
      padding: 40px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        margin-top: 20px;
        font-size: 24px;
        color: $color-primary;
        font-weight: 500;
      }
      .text {
        margin: 24px 0px;
        font-size: 18px;
        color: $color-gray-8;
      }
    }
  }
}
</style>
